import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const BarsArrowUpIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/bars-arrow-up"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M2.40002 4.49998C2.40002 4.00292 2.80297 3.59998 3.30002 3.59998H17.1C17.5971 3.59998 18 4.00292 18 4.49998C18 4.99703 17.5971 5.39998 17.1 5.39998H3.30002C2.80297 5.39998 2.40002 4.99703 2.40002 4.49998ZM2.40002 8.99998C2.40002 8.50292 2.80297 8.09998 3.30002 8.09998H10.9377C11.4348 8.09998 11.8377 8.50292 11.8377 8.99998C11.8377 9.49703 11.4348 9.89998 10.9377 9.89998H3.30002C2.80297 9.89998 2.40002 9.49703 2.40002 8.99998ZM16.8 8.39997C17.0503 8.39997 17.2892 8.50418 17.4595 8.68757L21.3595 12.8876C21.6978 13.2518 21.6767 13.8213 21.3124 14.1595C20.9482 14.4977 20.3787 14.4766 20.0405 14.1124L17.7 11.5919L17.7 19.5C17.7 19.997 17.2971 20.4 16.8 20.4C16.303 20.4 15.9 19.997 15.9 19.5L15.9 11.5919L13.5595 14.1124C13.2213 14.4766 12.6519 14.4977 12.2876 14.1595C11.9234 13.8213 11.9023 13.2518 12.2405 12.8876L16.1405 8.68757C16.3108 8.50418 16.5498 8.39997 16.8 8.39997ZM2.40002 13.5C2.40002 13.0029 2.80297 12.6 3.30002 12.6H8.40001C8.89706 12.6 9.30001 13.0029 9.30001 13.5C9.30001 13.997 8.89706 14.4 8.40001 14.4H3.30002C2.80297 14.4 2.40002 13.997 2.40002 13.5Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BarsArrowUpIcon;